"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RichContentLink = void 0;
const react_1 = __importDefault(require("react"));
const rich_content_element_1 = require("../rich-content-element");
const styles_1 = require("./styles");
const RichContentLink = ({ path = 'root', children, bold, italic, fontSize }) => {
    const goToUrl = (url) => {
        if (!url) {
            return;
        }
        window.open(url, '_blank');
    };
    if (!children) {
        return null;
    }
    if (typeof (children === null || children === void 0 ? void 0 : children.content.text) === 'string') {
        return react_1.default.createElement(styles_1.StyledLink, { onClick: () => goToUrl(children.url) }, children.content.text);
    }
    else {
        return (react_1.default.createElement(styles_1.StyledLink, { onClick: () => goToUrl(children.url) },
            react_1.default.createElement(rich_content_element_1.RichContentElement, { bold: bold, italic: italic, path: path, fontSize: fontSize, "data-cy": "link" }, children.content)));
    }
};
exports.RichContentLink = RichContentLink;
